import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  BillJournalData,
  BillJournalPrintRequest,
  BillJournalPrintResponse,
  BillJournalSearchRequest
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/bill-journal`;

export const searchBillJournal = (
    billJournalSearchRequest: BillJournalSearchRequest,
    source: CancelTokenSource): Promise<BillJournalData> => {
  return axios
      .post(`${apiUri}/search`, billJournalSearchRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const getBillJournalPrintPreview = (billJournalPrintRequest: Partial<BillJournalPrintRequest>,
                                           source: CancelTokenSource): Promise<BillJournalPrintResponse> => {
  return axios
      .post(`${apiUri}/output`, billJournalPrintRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const getBillJournalPdfUrl = (billJournalPdfId: string, billJournalPdfName: string) => {
  return `${baseUrl}/08d97fcc14e445e8b32a3830d640ad68/${billJournalPdfId}/${billJournalPdfName}`;
};
